const home = { label: "Home", href: "/" };

export const seoConfig = {
  home: {
    title: "Millennium Infotech – Digital Transformation, Cloud, Data & AI Services",
    description:
      "Millennium Infotech is a Microsoft Gold Partner delivering Generative AI, digital transformation, cloud, data intelligence, and IT staffing services that help enterprises modernize and grow.",
    keywords: [
      "digital transformation services",
      "generative ai services",
      "it staffing solutions",
      "cloud modernization",
      "data intelligence services",
      "microsoft gold partner",
    ],
    path: "/",
    image: "/assets/banner-2.jpg",
    crumbs: [home],
  },
  about: {
    title: "About Us",
    description:
      "20+ years pioneering technology solutions. Meet the leadership team behind Millennium Infotech's AI, cloud, data, and staffing services, trusted by 500+ clients worldwide.",
    keywords: ["about millennium infotech", "microsoft gold partner company", "it services company usa"],
    path: "/about",
    image: "/assets/About_us.jpg",
    crumbs: [home, { label: "About Us" }],
  },
  careers: {
    title: "Careers",
    description:
      "Explore current job openings at Millennium Infotech and grow your career with a team building AI, cloud, and enterprise technology solutions.",
    keywords: ["millennium infotech careers", "it jobs", "technology careers usa"],
    path: "/careers",
    crumbs: [home, { label: "Careers" }],
  },
  ourProducts: {
    title: "Our Products",
    description:
      "Discover Millennium Infotech's product suite: Signulu eSignature software, QuikHyr AI recruitment platform, a secure Document Management System, and the Attainica staffing ERP.",
    keywords: [
      "signulu esignature software",
      "quikhyr ai recruitment platform",
      "document management system",
      "attainica staffing erp",
    ],
    path: "/our-products",
    image: "/assets/banner-signulu.jpg",
    crumbs: [home, { label: "Our Products" }],
  },
  technologyServices: {
    title: "Technology Services",
    description:
      "Maximize your business potential with Millennium Infotech's technology services: Generative AI, digital transformation, business applications, data intelligence, and apps & infrastructure.",
    keywords: ["technology services", "enterprise it solutions", "managed technology services"],
    path: "/services/technology-services",
    image: "/assets/IT-Banner.jpg",
    crumbs: [home, { label: "Technology Services" }],
  },
  generativeAI: {
    title: "Generative AI Services",
    description:
      "Unlock new levels of creativity and efficiency with Millennium Infotech's Generative AI services, from ideation and model fine-tuning to secure enterprise integration.",
    keywords: [
      "generative ai services",
      "enterprise generative ai",
      "ai consulting services",
      "custom ai models for business",
    ],
    path: "/services/generative-ai",
    image: "/assets/Gen_AI-1.jpg",
    crumbs: [
      home,
      { label: "Technology Services", href: "/services/technology-services" },
      { label: "Generative AI Services" },
    ],
  },
  digitalTransformation: {
    title: "Digital Transformation Services",
    description:
      "Modernize your IT infrastructure and drive innovation with Millennium Infotech's digital transformation services: cloud modernization, process automation, and change management.",
    keywords: [
      "digital transformation strategy",
      "cloud modernization",
      "business process automation",
      "legacy system modernization",
    ],
    path: "/services/digital-transformation",
    image: "/assets/Transform.jpg",
    crumbs: [
      home,
      { label: "Technology Services", href: "/services/technology-services" },
      { label: "Digital Transformation" },
    ],
  },
  businessApplications: {
    title: "Business Application Services",
    description:
      "Millennium Infotech monitors, maintains, and upgrades business applications with proactive support, ensuring your systems run seamlessly, securely, and efficiently.",
    keywords: ["business application services", "application maintenance and support", "erp and crm support"],
    path: "/services/business-applications",
    image: "/assets/Business.jpg",
    crumbs: [
      home,
      { label: "Technology Services", href: "/services/technology-services" },
      { label: "Business Applications" },
    ],
  },
  dataIntelligence: {
    title: "Data and Intelligence Services",
    description:
      "Turn scattered data into trusted decisions. Millennium Infotech curates, unifies, and visualizes enterprise data for reliable, real-time business intelligence.",
    keywords: [
      "data intelligence services",
      "business intelligence solutions",
      "data analytics strategy",
      "data visualization services",
    ],
    path: "/services/data-and-intelligence",
    image: "/assets/Data.jpg",
    crumbs: [
      home,
      { label: "Technology Services", href: "/services/technology-services" },
      { label: "Data and Intelligence" },
    ],
  },
  appsInfrastructure: {
    title: "Apps and Infrastructure Services",
    description:
      "Build modern, scalable applications on the right infrastructure. Millennium Infotech delivers secure, high-performance apps and infrastructure services for growing enterprises.",
    keywords: ["application development services", "cloud infrastructure services", "scalable app infrastructure"],
    path: "/services/apps-and-infrastructure",
    image: "/assets/Application.jpg",
    crumbs: [
      home,
      { label: "Technology Services", href: "/services/technology-services" },
      { label: "Apps and Infrastructure" },
    ],
  },
  professionalServices: {
    title: "Professional Services & IT Staffing",
    description:
      "Elevate your team with top-tier talent. Millennium Infotech provides managed solutions, salaried professionals, and specialized staffing across data, ERP, security, and digital projects.",
    keywords: ["it staffing services", "professional services staffing", "managed it consultants"],
    path: "/services/professional-services",
    crumbs: [home, { label: "Professional Services" }],
  },
  contact: {
    title: "Contact Us",
    description:
      "Get in touch with Millennium Infotech for questions about our AI, cloud, data, and staffing services. Offices in the USA, Canada, and India.",
    keywords: ["contact millennium infotech", "it services near me", "millennium infotech offices"],
    path: "/contact",
    crumbs: [home, { label: "Contact Us" }],
  },
  blogListing: {
    title: "Blog & Insights",
    description:
      "Practical insights on generative AI, digital transformation, and data intelligence from Millennium Infotech's engineering and consulting teams.",
    keywords: ["millennium infotech blog", "generative ai insights", "digital transformation insights"],
    path: "/blog",
    crumbs: [home, { label: "Blog" }],
  },
  notFound: {
    title: "Page Not Found",
    description: "The page you're looking for doesn't exist or may have moved.",
    path: "/404",
    noindex: true,
  },
};
